/*
 * File: ui-label.ts
 * File Created: 2023-12-18 11:45:26
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-06 01:54:55
 * Modified By: Val Liu
 * -----
 */

import { StringHelper } from "../utilities";
import {
    BaseUITag,
    EUITagRuleType,
    EUITagRuleUnion,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    UITag,
} from "./core";
import { lang } from "@root/core/i18n";

// @uiDescription - add description to form element.

@UITag.set()
export class uiDescription extends BaseUITag {
    appliedTo: EUITagTarget[] = [EUITagTarget.FormElement];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.String];
    allowNullRule: boolean = false;

    /// set props :description
    parse(input: IUITagInput): IUITagResult | null {
        const rule = this.parseRule(input);
        if (rule == null) return null;

        /// normal case
        return {
            props: { description: lang.translate(rule as string) },
        };
    }
}
